import {
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
  onAuthStateChanged
} from 'firebase/auth';
import { ref, get } from 'firebase/database';
import { auth, database } from './firebase';

export const authService = {
  // Login admin user
  login: async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);

      // Check if user is admin
      const adminRef = ref(database, `admins/${userCredential.user.uid}`);
      const snapshot = await get(adminRef);

      if (!snapshot.exists()) {
        await signOut(auth);
        throw new Error('Unauthorized: Not an admin user');
      }

      return userCredential.user;
    } catch (error) {
      throw error;
    }
  },

  // Logout
  logout: async () => {
    try {
      await signOut(auth);
    } catch (error) {
      throw error;
    }
  },

  // Reset password
  resetPassword: async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
    } catch (error) {
      throw error;
    }
  },

  // Monitor auth state
  onAuthChange: (callback) => {
    return onAuthStateChanged(auth, callback);
  },

  // Get current user
  getCurrentUser: () => {
    return auth.currentUser;
  },

  // Check if user is admin
  isAdmin: async (uid) => {
    try {
      const adminRef = ref(database, `admins/${uid}`);
      const snapshot = await get(adminRef);
      return snapshot.exists();
    } catch (error) {
      return false;
    }
  }
};
